/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AddColumnIcon = /*#__PURE__*/ createSvgIcon(
  'AddColumnIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.75 4.5H4v11h4.75v-11zM4 17c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 01-.44-1.06v-11c0-.412.147-.766.44-1.06C3.235 3.148 3.588 3 4 3h11c.412 0 .766.147 1.06.44.293.293.44.645.44 1.056v.749c0 .212-.072.39-.214.536a.714.714 0 01-.532.219.734.734 0 01-.535-.216A.72.72 0 0115 5.25V4.5h-4.75v11H15v-.746c0-.21.072-.39.214-.535a.714.714 0 01.532-.219c.21 0 .39.072.535.216a.723.723 0 01.219.536v.752c0 .414-.147.767-.44 1.059A1.45 1.45 0 0115 17H4zm11.754-4.5a.734.734 0 01-.535-.216.72.72 0 01-.219-.534v-1h-1a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 0114 9.25h1v-1c0-.213.072-.39.214-.534a.72.72 0 01.532-.216c.21 0 .39.072.535.216a.72.72 0 01.219.534v1h1c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-1v1c0 .213-.072.39-.214.534a.72.72 0 01-.532.216z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default AddColumnIcon;
